export default "images/L5.jpg";